import React, { useState, useEffect } from "react";

//Sweet alert
import Swal from "sweetalert2";

//Services
import api from "../services/api";

//Components
import {
  Input,
  Button,
  Textarea
} from "../components";

import {
  useForm
} from "react-hook-form";

import {
  yupResolver
} from "@hookform/resolvers/yup";

import * as yup from "yup";

//Context
import {
  useAuth
} from "../providers/auth";

import {
  useParams,
  useNavigate
} from "react-router-dom";

const schema = yup.object({
  command: yup.string().required("O campo comando precisa ser preenchido!").matches(/^\S+$/, "O comando não pode conter espaços em branco."),
  body: yup.string().required("O campo texto precisa ser preenchido!")
}).required();

export default function Preset(props) {

  let params = useParams();

  const [loading, setLoading] = useState(false);
  const { register, reset, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(schema) });
  const { user } = useAuth();
  const token = { headers: { "Authorization": "Bearer " + user.token } };

  let navigate = useNavigate();

  async function fetchPreset() {
    setLoading(true);

    try {
      const response = await api.get("/presets/"+params.command, token);

      reset(response.data);

      if (response.data.error) {
        let icon = "error";
        let title = "Ocorreu um erro";
        let text = response.data.message;

        openAlert(icon, title, text);
      }

    } catch (e) {
      let icon = "error";
      let title = "Erro";
      let text = "Ocorreu um erro na sua solicitação.";

      openAlert(icon, title, text);
    } finally {
      setLoading(false);
    }
  };

  async function onSubmit(data) {
    setLoading(true);

    try {
      const response = await api.post("/presets/"+params.command, data, token);

      if (!response.data.error) {
        reset();

        let icon = "success";
        let title = "Success";
        let text = response.data.message;

        openAlert(icon, title, text);

        navigate("/utils/presets");
      } else {
        let icon = "error";
        let title = "Ocorreu um erro";
        let text = response.data.message;

        openAlert(icon, title, text);
      }
    } catch (e) {
      let icon = "error";
      let title = "Erro";
      let text = "Ocorreu um erro na sua solicitação.";

      openAlert(icon, title, text);
    } finally {
      setLoading(false);
    }
  };

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer)
      toast.addEventListener("mouseleave", Swal.resumeTimer)
    }
  });

  const openAlert = (icon, title, text) => {
    Toast.fire({
      icon,
      title,
      text
    });
  };

  useEffect(() => {
    fetchPreset()
  }, [params.command]);

  return (
    <div className="u-d-flex flex-column justify-content-center align-center u-mt-100">
      <div className="white-box mt-1">

        <form onSubmit={handleSubmit(onSubmit)}>
          <Input
            label="Comando do preset"
            type="text"
            placeholder="tudo_bem"
            name="command"
            register={register}
            error={errors.command}
          />

          <Textarea
            label="Texto"
            type="text"
            placeholder="Olá, tudo bem? [...]"
            name="body"
            register={register}
            error={errors.body}
          />

          <Button
            title="Editar preset"
            color="green"
            width="full"
            styles="mt-20"
            loading={loading}
          />
        </form>
      </div>
    </div>
  );
}